<template>
  <div>
    <campaign-list
      :tableColumns="config.columns"
      :params="config.params"
      :filterBtnShow="true"
    ></campaign-list>
  </div>
</template>

<script>
import { created } from 'vue-echarts';
import CampaignList from './Links.vue'
import axiosIns from '@/axios.js';
import { watch } from 'vue';

export default {
  components: {
    CampaignList,
  },
  data() {
    return {
      linkConfigs: {
        influencer: {
          title: "Fenomen Paylaşımları",
          columns: [
            { key: 'id', sortable: true },
            { key: 'username', label: 'Fenomen', sortable: true },
            { key: 'campaign_name', label: 'Paylaşım', sortable: true },
            { key: 'start_date',label:'Başlama Tarihi', sortable: false },
            { key: 'end_date',label:'Bitiş Tarihi', sortable: false },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 0 },
            source: 'list',
          },
        },
        story: {
          title: "Story Paylaşımları",
          columns: [
            { key: 'id', sortable: true },
            { key: 'image', label: 'Story Görsel', sortable: true },
            { key: 'is_internal_domain', label: 'Bağlantı Türü', sortable: false },
            { key: 'campaign_name', label: 'Paylaşım', sortable: true },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 1 },
            source: 'list',
          },
        },
        sms: {
          title: "Sms Paylaşımları",
          columns: [
            { key: 'id', sortable: true },
            { key: 'is_internal_domain', label: 'Bağlantı Türü', sortable: false },
            { key: 'campaign_name', label: 'Paylaşım', sortable: true },
            { key: 'description',label:'Mesaj İçeriği', sortable: false },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 2 },
            source: 'list',
          },
        },
        whatsapp: {
          title: "Whatsapp Paylaşımları",
          columns: [
            { key: 'id', sortable: true },
            { key: 'is_internal_domain', label: 'Bağlantı Türü', sortable: false },
            { key: 'campaign_name', label: 'Paylaşım', sortable: true },
            { key: 'description',label:'Mesaj İçeriği', sortable: false },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 4 },
            source: 'list',
          },
        },
        email: {
          title: "Email Paylaşımları",
          columns: [
            { key: 'id', sortable: true },
            { key: 'is_internal_domain', label: 'Bağlantı Türü', sortable: false },
            { key: 'campaign_name', label: 'Paylaşım', sortable: true },
            { key: 'description',label:'Mesaj İçeriği', sortable: false },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 5 },
            source: 'list',
          },
        },
        banner: {
          title: "Banner",
          columns: [
            { key: 'id', sortable: true },
            { key: 'image', label: 'Banner', sortable: true, multiShow: false },
            { key: 'is_internal_domain', label: 'Bağlantı Türü', sortable: false },
            { key: 'campaign_name', label: 'Banner Adı', sortable: true },
            { key: 'created_date', label: 'Oluşturulma Tarihi', sortable: true },
            { key: 'event_count',label:'Ziyaret', sortable: false },
            { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
            { key: 'order_count',label:'Sipariş Adedi', sortable: false },
            { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
            { key: 'status', label: 'Durum'},
            { key: 'actions', label: 'Detay'},
          ],
          params: {
            filter: { type: 7 },
            source: 'list',
          },
        }
      },
    }
  },
  created() {
  },  
  methods: {
  },
  computed: {
    config() {
      const type = this.$route.params.type
      return this.linkConfigs[type] ?? this.linkConfigs['influencer']
    },
  },
}
</script>
